import React from 'react';
import { useTranslation } from 'react-i18next';
import BackendText, { BackendHeading } from './BackendText';

const ProjectCard = ({
  project,
  index,
  isBackendContent = true,
  className = ''
}) => {
  const { t } = useTranslation();
  
  const displayProject = project;
  
  return (
    <article
      className={`group relative bg-white border-2 border-black hover:border-gray-400 transition-all duration-500 ${className}`}
    >
      {/* Project Number */}
      <div className="absolute -top-4 -left-4 w-12 h-12 bg-black text-white flex items-center justify-center font-black text-lg z-10">
        {String(index + 1).padStart(2, '0')}
      </div>
      
      <div className="overflow-hidden">
        <img
          src={displayProject.image}
          alt={displayProject.name}
          className="w-full aspect-[4/3] object-cover transition-all duration-500"
        />
        <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-0 transition-all duration-500"></div>
      </div>
      
      <div className="p-8">
        {isBackendContent ? (
          <BackendHeading 
            text={displayProject.name} 
            i18nKey={`projects_page.project_${index}.name`}
            fallback={displayProject.name}
            className="text-xl font-black mb-4 uppercase tracking-wider text-black group-hover:text-gray-700 transition-colors duration-300"
          />
        ) : (
          <h3 className="text-xl font-black mb-4 uppercase tracking-wider text-black group-hover:text-gray-700 transition-colors duration-300">
            {displayProject.name}
          </h3>
        )}
        
        <div className="w-16 h-1 bg-black mb-4 group-hover:w-24 transition-all duration-300"></div>
        
        {isBackendContent ? (
          <BackendText 
            text={displayProject.description} 
            i18nKey={`projects_page.project_${index}.description`}
            fallback={displayProject.description}
            as="p"
            className="text-gray-700 mb-6 leading-relaxed"
          />
        ) : (
          <p className="text-gray-700 mb-6 leading-relaxed">{displayProject.description}</p>
        )}

        {displayProject.details && (
          <details className="text-sm text-gray-700 group">
            <summary className="cursor-pointer font-bold text-black uppercase tracking-wide hover:text-gray-600 transition-colors duration-300 list-none">
              <span className="flex items-center">
                {t('read_more', { defaultValue: 'Read more' })}
                <svg className="ml-2 w-4 h-4 transform group-open:rotate-180 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </span>
            </summary>
            <div className="mt-4 pt-4 border-t border-gray-200 leading-relaxed text-gray-600">
              {isBackendContent ? (
                <BackendText 
                  text={displayProject.details} 
                  i18nKey={`projects_page.project_${index}.details`}
                  fallback={displayProject.details}
                />
              ) : (
                displayProject.details
              )}
            </div>
          </details>
        )}
      </div>
      
      {/* Corner Accent */}
      <div className="absolute bottom-0 right-0 w-8 h-8 bg-black transform translate-x-2 translate-y-2 group-hover:translate-x-1 group-hover:translate-y-1 transition-transform duration-300"></div>
    </article>
  );
};

export default ProjectCard;
